import axios from 'axios'
import attr from '../../vue.config'


export async function post(Url,param){
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: attr.devServer.proxy['/api'].target + '/' + Url,
        data: param,
        timeout: 12000,
        traditional: true,
        Headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        resolve(res.data)
      }).catch(function (error) {
        let data={
          head:{
            message:'',
            status:'0'
          }
        }
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
          data.head.message="请求超时"
        } else {
          data.head.message="请求错误:"+error.message
        }
        resolve(data)
      })
    })
    
}




export async function get (Url, param) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: attr.devServer.proxy['/api'].target + '/' + Url,
      params: param,
      timeout: 10000,
      traditional: true,
      Headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => {
      resolve(res.data)
    }).catch(function (error) {
      let data={
        head:{
          message:'',
          status:'0'
        }
      }
      if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
        data.head.message="请求超时"
      } else {
        data.head.message="请求错误:"+error.message
      }
      resolve(data)
    })
  })
}












// 输出格式化时间
export function FormateDate (time, typ) {
  if(time===undefined||time===null)
    return ''
  else{
    var date = new Date(time)
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var seconds = date.getSeconds()
    var t1 = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day)
    var t2 = (hours < 10 ? '0' + hours : hours) + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds)
    if (typ === 0) { return t1 }
    if (typ === 1) { return t2 }
    if (typ === 2) { return t1 + ' ' + t2 }
  }
}
